import React from 'react';

function Services() {
  return (
    <section id="services">
      <h2>Our Services</h2>
      <div className="services">
        <div className="card">
          <h3>Personal Banking</h3>
          <p>Checking, savings, and personalized banking solutions designed for everyday life.</p>
        </div>
        <div className="card">
          <h3>Business Banking</h3>
          <p>Business accounts, merchant services, and loans to help your company grow.</p>
        </div>
        <div className="card">
          <h3>Investments</h3>
          <p>Plan your future with competitive rates and expert advice on savings and retirement options.</p>
        </div>
      </div>
    </section>
  );
}

export default Services;